export class AbaloneFailure {
    static CANNOT_MOVE_MORE_THAN_N_PIECES = (n) => $localize `You cannot move more than ${n} of your pieces!`;
    static NOT_ENOUGH_PIECE_TO_PUSH = () => $localize `You don't have enough pieces to push that group!`;
    static CANNOT_PUSH_YOUR_OWN_PIECES = () => $localize `You cannot push this piece because it is blocked by one of yours!`;
    static MUST_ONLY_TRANSLATE_YOUR_PIECES = () => $localize `This line contains pieces of your opponent or empty spaces, which is forbidden.`;
    static TRANSLATION_IMPOSSIBLE = () => $localize `This move is impossible, some landing spaces are occupied.`;
    static LINE_AND_COORD_NOT_ALIGNED = () => $localize `This space is not aligned with the current line.`;
}
